import { addCommasToNumber, DataItem } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'
import moment from 'moment'
import React from 'react'
import { formatters } from '@utils/intl/dateTimeFormatters'

import { titleCase } from '../../../utils/general'

export function DefaultDetailsContainer({ details, detailKeys }) {
  return (
    <div className='details-container'>
      <Row flex justify='space-between'>
        {detailKeys &&
          detailKeys.map((key) => {
            if (key === 'old_supply_option' || key === 'new_supply_option' || key === 'old_flags') return
            const hasValue = !!details[key] || details[key] === false
            if (hasValue) {
              return (
                <Col key={key} span={12}>
                  <DataItem label={titleCase(key)}>
                    <p style={{ whiteSpace: 'break-spaces' }}>
                      {isNaN(details[key])
                        ? moment(details[key], moment.ISO_8601, true).isValid()
                          ? formatters.DATE_TIME(moment(details[key]), details[`${key}_local`])
                          : typeof details[key] !== 'object' && details[key]
                        : addCommasToNumber(details[key], 4)}
                    </p>
                  </DataItem>
                </Col>
              )
            }
            return null
          })}
      </Row>
    </div>
  )
}
